import Vue from "vue";
import Vuex from "vuex";
import state from "./state";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";

Vue.use(Vuex);

const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions
});

const token = localStorage.getItem("token");
const user = JSON.parse(localStorage.getItem("user"));

store.commit("LOGIN", { accessToken: token, user: user, user_db: {} });

export default store;
